/* eslint-disable */
import React, { useState } from "react";
import {
  Card,
  ScrollArea,
  Table,
  Avatar,
  Group,
  Text,
  Badge,
  Box,
  useMantineTheme,
} from "@mantine/core";

import { useGetImpersonableUsers } from "api/superAdmin/userOrganization";
import { useImpersonateUser } from "api/superAdmin/userSuperAdminId";
import LoginModal from "./components/LognModal";
import { useDisclosure } from "@mantine/hooks";
import CardAdmin from "./components/card";
import { useGetUser } from "api/users/getUser";

export default function UserTableOrg() {
  const theme = useMantineTheme();
  const { data } = useGetImpersonableUsers();
  const { data: user } = useGetUser();

  const [opened, setOpened] = useState(false);
  const [loginUser, setLoginUser] = useState({
    id: "",
    userName: "",
  });
  const handleClose = async () => {
    setOpened(false);
  };
  const colors = ["#5c4bff", "#00b894", "#e17055"];
  const cols = ["purple", "green", "orange"];

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "white",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          padding: "10px",
        }}
      >
        <Group spacing="sm">
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px 12px",
            }}
          >
            <Text weight={700}>
              {" "}
              {`${user?.firstName?.trim().charAt(0).toUpperCase() ?? ""} ${
                user?.lastName
                  ? user?.lastName?.trim().charAt(0).toUpperCase() + " "
                  : ""
              }`}
            </Text>
          </Box>
          <Box>
            <Text weight={700} size="lg" color="black">
              {`${user?.firstName} ${user?.lastName}`}
            </Text>
            <Text size="sm" color="black" opacity={0.8}>
              System-wide dashboard and management
            </Text>
          </Box>
        </Group>
        <Group spacing="sm">
          <Box
            sx={{
              backgroundColor: "#5c4bff",
              borderRadius: "8px",
              padding: "8px 12px",
            }}
          >
            <Text weight={700} color="black">
              {`${user?.firstName?.trim().charAt(0).toUpperCase() ?? ""} ${
                user?.lastName
                  ? user?.lastName?.trim().charAt(0).toUpperCase() + " "
                  : ""
              }`}
            </Text>
          </Box>
          <Box>
            <Text weight={700} color="black">
              {`${user?.firstName} ${user?.lastName}`}
            </Text>
            <Text size="sm" color="black" opacity={0.8}>
              {user?.email}
            </Text>
          </Box>
        </Group>
      </Box>
      <CardAdmin />
      <Card p="xl" radius="md" shadow="sm">
        <ScrollArea>
          <Table verticalSpacing="lg" fontSize="md" striped highlightOnHover>
            <thead>
              <tr>
                <th>Name</th>
                {/* <th>Email</th> */}
                <th>Organization</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {data?.map((user, idx) => {
                const initials = `${user?.firstName?.charAt(
                  0
                )}${user?.lastName?.charAt(0)}`.toUpperCase();
                const bg =
                  theme.colorScheme === "dark"
                    ? theme.colors.dark[6]
                    : theme.colors.gray[1];

                return (
                  <tr key={user?._id}>
                    <td>
                      <Group spacing="sm">
                        <Box
                          sx={{
                            backgroundColor: colors[idx % colors.length],

                            borderRadius: "8px",
                            padding: "8px 12px",
                          }}
                        >
                          <Text weight={700} color="white">
                            {initials}
                          </Text>
                        </Box>

                        <Box>
                          <Text
                            fw={600}
                          >{`${user?.firstName} ${user?.lastName}`}</Text>
                          <Text size="sm" c="dimmed">
                            {user?.email}
                          </Text>
                        </Box>
                      </Group>
                    </td>

                    <td>
                      <Badge
                        radius="sm"
                        variant="light"
                        color={cols[idx % cols.length]}
                      >
                        {user?.org?.name}
                      </Badge>
                    </td>

                    <td>
                      <Group spacing="xs">
                        <Badge radius="sm" variant="light" color="purple">
                          {user?.role}
                        </Badge>
                      </Group>
                    </td>
                    <td>
                      <Group
                        spacing="xs"
                        onClick={() => {
                          setLoginUser({
                            userName: `${user?.firstName} ${user?.lastName}`,
                            id: user?._id,
                          });
                          setOpened(true);

                          // handleClose();
                        }}
                        // onClick={() => mutate(user._id)}
                        style={{ cursor: "pointer" }}
                      >
                        <Badge radius="sm" variant="light" color="purple">
                          View
                        </Badge>
                      </Group>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </ScrollArea>
        <LoginModal
          opened={opened}
          onClose={handleClose}
          loginUser={loginUser}
        />
      </Card>
    </Box>
  );
}
